import { PermissionName } from '@vetahealth/fishing-gear/permissions'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { ManualOrdersList } from '../../components/Widgets/ManualOrders'
import { useUserStore } from '../../stores/user'
import { routes } from '.'
import { GenericWrapper } from './styles'

export function ManualOrders(): React.ReactNode {
  const navigate = useNavigate()
  const [hasSomePermission] = useUserStore((state) => [state.hasSomePermission])

  useEffect(() => {
    if (!hasSomePermission(PermissionName.dispatchManualOrder)) {
      navigate(routes.patientList(), { replace: true })
      return
    }
  }, [])

  return (
    <GenericWrapper>
      <ManualOrdersList />
    </GenericWrapper>
  )
}
